import { throttle } from 'lodash'
import React from 'react'

const RESIZE_THROTTLE_MS = 500

export default function withEsMovil(WrappedComponent) {
  class WithEsMovil extends React.Component {
    constructor(props) {
      super(props)

      this.anchoMovil = 1199

      this.state = { esMovil: false }

      this.windowResize = throttle(this.handleWindowResize, RESIZE_THROTTLE_MS)
    }

    componentDidMount() {
      this.windowResize()
      window.addEventListener('resize', this.windowResize)
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.windowResize)
    }

    handleWindowResize = () => {
      this.setState({ esMovil: window.innerWidth <= this.anchoMovil })
    }

    render() {
      return <WrappedComponent esMovil={this.state.esMovil} {...this.props} />
    }
  }

  WithEsMovil.displayName = `WithEsMovil(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`

  return WithEsMovil
}
